<h3 class="title-divider">{{ heading | translate }}</h3>
<fieldset [disabled]="disabled" capAtLeastOneValidator ngModelGroup="EingabeMussMindestensEinePersonenartAusgewaehltHaben">
  <cap-form-control labelKey="NatuerlichePerson">
    <input
      (ngModelChange)="model && (model.natuerlichePerson = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.natuerlichePerson"
      name="natuerlichePerson"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="JuristischePerson">
    <input
      (ngModelChange)="model && (model.juristischePerson = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.juristischePerson"
      name="juristischePerson"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="OeffentlichRechtlicheKoerperschaft">
    <input
      (ngModelChange)="model && (model.oeffentlichRechtlicheKoerperschaft = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.oeffentlichRechtlicheKoerperschaft"
      name="oeffentlichRechtlicheKoerperschaft"
      type="checkbox" />
  </cap-form-control>
</fieldset>
